import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"
import type { ITransferForm } from "@app/dashboard/types/innerLayout/bills/transfer-modal";
import type { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  allow403?: boolean;
};

export const sendOTP = (payload: ITransferForm) => {
  const {
    receiver_merchant_id,
    amount,
    save_beneficiary
  } = payload;

  const params = {
    receiver_merchant_id,
    amount,
    ...(save_beneficiary ? {
      save_beneficiary,
    } : {}),
  };

  return axiosPrivate.post('/bills/api/v1/distributor/transfer_send_otp/', params, { allow403: true } as CustomAxiosRequestConfig);
}